<template>
    <div>
        <BodycheckYuyue />
    </div>
</template>

<script>
import BodycheckYuyue from "./bodycheckYuyueView.vue";
export default {
    components: {
        BodycheckYuyue,
    },
    data() {
        return{
            
        }
    },
    created(){
        
    }
};
</script>
